module.exports = __webpack_public_path__ + "static/media/cactus_1.7afbf47f.png";